export const categoriesConstants = {
    GETCATEGORIES_SUCCES: 'GET_CATEGORIES_SUCCES'
};
